import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { ApiService } from '../api.service'
import { Subscription } from 'rxjs'

@Component({
	selector: 'generate-questions-moodle',
	templateUrl: './generate-questions-moodle.component.html',
	styleUrl: './generate-questions-moodle.component.scss'
})

export class GenerateQuestionsMoodleComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() course = 0
	units: any[] = []
	state: 'idle' | 'loading' | 'success' | 'error' = 'idle'
	unitQuestions: any[] = []
	showQuestions = false

	getCourseUnits = new Subscription
	getUnitLessons = new Subscription
	generateQuestionsMoodle = new Subscription

	constructor(private dataService: ApiService) {}

	ngOnInit() {
		this.getCourseUnits = this.dataService.getCourseUnits(this.course)
		.subscribe({
			next: units => {
				// console.log(units)

				units.forEach((unit: any) => {
					let unitID = unit.id
					if (unitID == 'unit_create') return

					unitID = +unitID.replace('unit_', '')
					let unitName = unit.name

					let unitLessons: any[] = []
					this.getUnitLessons = this.dataService.getUnitLessons(unitID)
					.subscribe({
						next: lessons => {
							// console.log(lessons)

							lessons.forEach((lesson: any) => {
								let lessonID = lesson.id
								if (!lessonID.includes('lesson')) return
								lessonID = +lessonID.replace('lesson_', '')
								// console.log(lesson)
								
								unitLessons.push({
									'id': lessonID,
									'name': lesson.name,
									'type': 'lesson',
									'checked': false,
								})
							})
						},
						error: err => {
							console.log(err)
						}
					})

					this.units.push({
						'id': unitID,
						'name': unitName,
						'type': 'unit',
						'lessons': unitLessons,
						'checked': false,
					})
				})

				console.log(this.units)
			},
			error: err => {
				console.log(err)
			},
		})
	}

	ngAfterViewInit() {}

	ngOnChanges() {}

	ngOnDestroy() {
		this.getCourseUnits?.unsubscribe()
		this.getUnitLessons?.unsubscribe()
		this.generateQuestionsMoodle?.unsubscribe()
	}

	check(obj: any) {
		console.log(obj)
		let objID = obj.id
		let objType = obj.type
		let checked = obj.checked
		if (objType == 'unit') {
			// let lessons: any[] = this.units.find((unit) => objID == unit.id).lessons
			// lessons.map((lesson) => lesson.checked = checked)
			this.units.find((unit) => objID == unit.id).lessons.map((lesson: any) => lesson.checked = checked)
		}
	}

	generateQuestions(event: Event) {
		this.state = 'loading'

		let units: any[] = []
		units = this.units
			.filter(unit => unit.checked)
			.map(({ checked, lessons, ...unitRest }) => ({
				...unitRest,
				lessons: lessons
					.filter((lesson: any) => lesson.checked)
					.map(({ checked, ...lessonRest }: any) => lessonRest)
			}))
		console.log(units)

		this.generateQuestionsMoodle = this.dataService.generateQuestionsMoodle(units)
		.subscribe({
			next: data => {
				console.log(data)
				console.log(data.units)
				this.state = 'success'
				this.unitQuestions = data.units
				console.log(this.unitQuestions)
			},
			error: err => {
				console.log(err)
				this.state = 'error'
			},
		})
	}

	exportQuestionsJSON() {
		let json = JSON.stringify(this.unitQuestions, null, "\t")
		let element = document.createElement('a')
		element.setAttribute('href', 'data:text/jsoncharset=UTF-8,' + encodeURIComponent(json))
		element.setAttribute('download', 'questions.json')
		element.style.display = 'none'
		document.body.appendChild(element)
		element.click()
		document.body.removeChild(element)
	}

}
